<div
  class="card"
  [class.card--elevation-sm]="elevation === 'sm'"
  [class.card--elevation-md]="elevation === 'md'"
  [class.card--elevation-lg]="elevation === 'lg'"
  [class.card--padding-sm]="padding === 'sm'"
  [class.card--padding-md]="padding === 'md'"
  [class.card--padding-lg]="padding === 'lg'"
  [class.card--rounded]="rounded"
>
  <ng-content></ng-content>
</div>
